import React from 'react';
import classNames from 'classnames';

const TaxonomyOrganization = ({ entity, className }) => {
  const classes = classNames(className, 'Organization');

  const logo = entity.getIn(['field_logo', 0, 'url']);
  const logoAlt = entity.getIn(['field_logo', 0, 'alt']);
  const email = entity.getIn(['field_email', 0, 'value']);
  const phone = entity.getIn(['field_phonenumber', 0, 'value']);
  const websiteLinkUri = entity.getIn(['field_website', 0, 'uri']);
  const websiteLinkTitle = entity.getIn(['field_website', 0, 'title']);

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <img src={logo} alt={logoAlt} className="Organization__logo" />
      <div className="Organization__links">
        <div><a href={`tel:${phone}`}><span>T</span>{phone}</a></div>
        <div><a href={`mailto:${email}`}><span>E</span>{email}</a></div>
        <div><a href={websiteLinkUri} target="_blank" rel="noreferrer" className="website">{websiteLinkTitle}</a></div>
      </div>
    </article>
  );
};

export default TaxonomyOrganization;
